import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";

export const eventBeam = createBeam(bifrost, "/game/event", {
    depth:1
});
